import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchMe, getCachedMe, isNotEmployee } from "../pages/employee/me";
import {
  fetchBadgeCounts,
  getCachedCounts,
  onBadgeCounts,
  totalCount,
} from "../pages/employee/notifications";

// 管理画面サイドバー最下部のアカウント＝勤怠マイページ(Guluu 勤怠)への入口。
// メニュー(.sidebar-scroll)だけがスクロールし、この入口は常にサイドバー底に固定される
// （スマホのドロワーでも同様。スタイルは index.css の .sidebar-acct）。
//
// 氏名・バッジ件数はマイページ側のサイドバー(.mp-acct)と同じAPIから取る＝両者で数字が食い違わない。
// 社員レコードが無い管理者は /api/employee/me/ が403＝マイページを開けないので、
// その場合は入口ごと出さない（開いても403になるリンクを見せない）。
function SidebarAccount({ onNavigate }) {
  // 初回はキャッシュから復元＝ページ遷移で再マウントされても氏名・バッジがちらつかない。
  const [me, setMe] = useState(getCachedMe);
  const [counts, setCounts] = useState(getCachedCounts);

  // マイページ側で承認・振り分け等をして件数が変わったら、ここにも即座に反映する。
  useEffect(() => onBadgeCounts(setCounts), []);

  useEffect(() => {
    if (isNotEmployee()) return undefined; // 社員でないと確定済み＝もう問い合わせない
    let alive = true;
    fetchMe().then((d) => {
      if (alive && d) setMe(d);
    });
    fetchBadgeCounts().then((c) => {
      if (alive) setCounts(c);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!me) return null; // 社員でない、または未取得のうちは動線を出さない

  const name = me.name || "";
  // 社員名の横の総数バッジ（未読の通知合計）。管理画面には勤怠側の現在地が無いので除外はしない。
  const total = totalCount(counts);

  return (
    <Link className="sidebar-acct" to="/employee" onClick={onNavigate}>
      <span className="sidebar-acct-avi">{name ? name.slice(0, 1) : "·"}</span>
      <span className="sidebar-acct-text">
        <span className="sidebar-acct-name">{name || "-"}</span>
        <span className="sidebar-acct-sub">勤怠マイページへ</span>
      </span>
      {total > 0 && (
        <span
          className="sidebar-acct-badge"
          aria-label={`未読の通知 合計${total}件`}
        >
          {total}
        </span>
      )}
      <svg
        className="sidebar-acct-chev"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 6l6 6-6 6" />
      </svg>
    </Link>
  );
}

export default SidebarAccount;
